import {
  GET_INTERNSHIP_STRUCTURES,
  GET_INTERNSHIP_STRUCTURES_FAIL,
  GET_INTERNSHIP_STRUCTURES_SUCCESS,
  ADD_NEW_INTERNSHIP_STRUCTURE,
  ADD_INTERNSHIP_STRUCTURE_SUCCESS,
  ADD_INTERNSHIP_STRUCTURE_FAIL,
  UPDATE_INTERNSHIP_STRUCTURE,
  UPDATE_INTERNSHIP_STRUCTURE_SUCCESS,
  UPDATE_INTERNSHIP_STRUCTURE_FAIL,
  DELETE_INTERNSHIP_STRUCTURE,
  DELETE_INTERNSHIP_STRUCTURE_SUCCESS,
  DELETE_INTERNSHIP_STRUCTURE_FAIL,
  
} from "./actionTypes";

export const getInternshipStructures = () => ({
  type: GET_INTERNSHIP_STRUCTURES,
})

export const getInternshipStructuresSuccess = internshipStructures => ({
  type: GET_INTERNSHIP_STRUCTURES_SUCCESS,
  payload: internshipStructures,
})

export const getInternshipStructuresFail = error => ({
  type: GET_INTERNSHIP_STRUCTURES_FAIL,
  payload: error,
})

export const addNewInternshipStructure = data => ({
  type: ADD_NEW_INTERNSHIP_STRUCTURE,
  payload: data,
})

export const addInternshipStructureSuccess = internshipStructure => ({
  type: ADD_INTERNSHIP_STRUCTURE_SUCCESS,
  payload: internshipStructure,
})

export const addInternshipStructureFail = error => ({
  type: ADD_INTERNSHIP_STRUCTURE_FAIL,
  payload: error,
})

export const updateInternshipStructure = internshipStructure => ({
  type: UPDATE_INTERNSHIP_STRUCTURE,
  payload: internshipStructure,
})

export const updateInternshipStructureSuccess = internshipStructure => ({
  type: UPDATE_INTERNSHIP_STRUCTURE_SUCCESS,
  payload: internshipStructure,
})

export const updateInternshipStructureFail = error => ({
  type: UPDATE_INTERNSHIP_STRUCTURE_FAIL,
  payload: error,
})

export const deleteInternshipStructure = data => ({
  type: DELETE_INTERNSHIP_STRUCTURE,
  payload: data,
})

export const deleteInternshipStructureSuccess = data => ({
  type: DELETE_INTERNSHIP_STRUCTURE_SUCCESS,
  payload: data,
})

export const deleteInternshipStructureFail = error => ({
  type: DELETE_INTERNSHIP_STRUCTURE_FAIL,
  payload: error,
})

export const resetInternshipStructureLastActionSuccess = () => ({
    type: "RESET_LAST_ACTION_SUCCESS"
});

